import ResetPasswordScreen from './ResetPasswordScreen'

export default ResetPasswordScreen



// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPasswordScreen/index.js